import { render, staticRenderFns } from "./RightAngleSvg copy.vue?vue&type=template&id=3232b139&"
import script from "./RightAngleSvg copy.vue?vue&type=script&lang=js&"
export * from "./RightAngleSvg copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports